<div class="student-card p-3 p-md-4 level-{{levelKey || 'default'}}">

  <div class="d-flex flex-column flex-lg-row align-items-lg-start justify-content-between mb-3">
    <div>
      <p class="fs-20 fw-800 color-gray-950 mb-0">
        <i class="bi bi-file-earmark-text color-brand-primary me-2"></i>{{'students.weekly_report.title'|translate}}
      </p>
      <p class="fs-small fw-400 color-gray-400 mb-0">
        {{'students.weekly_report.subtitle'|translate: {name: student?.name} }}
      </p>
    </div>

    <div class="d-flex align-items-center mt-3 mt-lg-0">
      <span class="level-badge fs-small fw-800 me-2" *ngIf="levelName">
        {{'students.navi_route.level_name'|translate: {level: levelName} }}
      </span>

      <app-gray-button
        color="stroke" [fullWidth]="false" padding="py-1 px-3" [weight]="500" customClass="fs-small"
        [text]="'students.weekly_report.copy'|translate" (click)="copyReport()"></app-gray-button>
    </div>
  </div>

  <ngx-skeleton-loader
    *ngIf="isLoading" count="1" appearance="line"
    [theme]="{height: '104px', 'border-radius': '12px', margin: '0 0 16px 0'}"/>

  <div class="row g-2" *ngIf="!isLoading">
    <div class="col-6 col-xl-3">
      <div class="stat-box p-3 h-100">
        <p class="fs-xsmall fw-800 color-gray-500 mb-2">
          <i class="bi bi-calendar-week me-1"></i>{{'students.weekly_report.plan'|translate|uppercase}}
        </p>
        <p class="fs-24 fw-800 color-gray-950 mb-0">%{{planPercent()}}</p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="planTotal">
          {{'students.weekly_report.plan_desc'|translate: {completed: planCompleted, total: planTotal} }}
        </p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="!planTotal">
          {{'students.weekly_report.plan_empty'|translate}}
        </p>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="stat-box p-3 h-100">
        <p class="fs-xsmall fw-800 color-gray-500 mb-2">
          <i class="bi bi-graph-up-arrow me-1"></i>{{'students.weekly_report.score_change'|translate|uppercase}}
        </p>
        <p class="fs-24 fw-800 mb-0"
           [class.color-brand-primary-700]="(scoreDelta ?? 0) >= 0" [class.color-danger]="(scoreDelta ?? 0) < 0">
          <ng-container *ngIf="scoreDelta !== null; else noDelta">
            {{scoreDelta > 0 ? '+' : ''}}{{scoreDelta}}
          </ng-container>
          <ng-template #noDelta>—</ng-template>
        </p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="lastScore !== null">
          {{'students.weekly_report.score_desc'|translate: {exam: examName, score: lastScore} }}
        </p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="lastScore === null">
          {{'students.weekly_report.score_empty'|translate}}
        </p>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="stat-box p-3 h-100">
        <p class="fs-xsmall fw-800 color-gray-500 mb-2">
          <i class="bi bi-clipboard-check me-1"></i>{{'students.weekly_report.tasks'|translate|uppercase}}
        </p>
        <p class="fs-24 fw-800 color-gray-950 mb-0">{{taskCompleted}}<span class="fs-normal color-gray-400">/{{taskTotal}}</span></p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0">
          {{'students.weekly_report.tasks_desc'|translate: {open: openTaskCount()} }}
        </p>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="stat-box p-3 h-100">
        <p class="fs-xsmall fw-800 color-gray-500 mb-2">
          <i class="bi bi-camera-video me-1"></i>{{'students.weekly_report.meetings'|translate|uppercase}}
        </p>
        <p class="fs-24 fw-800 color-gray-950 mb-0">{{meetingsDone()}}</p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0">
          {{'students.weekly_report.meetings_desc'|translate: {next: meetingsNext()} }}
        </p>
      </div>
    </div>
  </div>

  <div class="summary-box p-3 p-md-4 mt-3" *ngIf="!isLoading">
    <p class="fs-xsmall fw-800 color-gray-500 mb-2">
      <i class="bi bi-bullseye me-1"></i>{{'students.weekly_report.summary_title'|translate|uppercase}}
    </p>

    <p class="fs-small fw-400 color-gray-950 mb-0" *ngIf="summaryLines().length">
      <ng-container *ngFor="let line of summaryLines()">{{line}} </ng-container>
    </p>

    <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!summaryLines().length">
      {{'students.weekly_report.summary_empty'|translate}}
    </p>
  </div>

</div>
